module.exports = __webpack_public_path__ + "static/media/vegitables_34.e8330f7e.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_34.csv
// module id = 618
// module chunks = 0